// One fictional, static demonstration used across the landing page (hero highlights + detailed panels).
// Illustrative copy only — not a real member, not a live AI response, never sent to the backend.
export const EXAMPLE = {
  nickname: "A.",
  label: "Illustrative example · shortened for this page",
  entitlementNote: "This example includes ongoing history, available on paid plans. Your first situation is free.",
  highlights: [
    { key: "what", label: "What happened", text: "They cancelled Friday dinner. I heard nothing over the weekend. Flowers arrived Monday. I'm still upset." },
    { key: "earlier", label: "Earlier, you wrote", text: "I told them I needed the weekend to myself." },
    { key: "picture", label: "A fuller picture", text: "They may have been giving you space. Friday still needs a conversation." },
    { key: "say", label: "Something you could say", text: "Thanks for the flowers. I'm still disappointed about Friday. Can we talk tonight?" },
  ],
  notes: [
    { when: "Fri", what: "Dinner cancelled · asked for the weekend" },
    { when: "Mon", what: "Flowers · still upset · asked to talk" },
    { when: "Mon +7", what: "Talked · apology · dinner Saturday" },
  ],
  panels: {
    heading: "A second look can change the picture.",
    intro: "An earlier detail can change the advice without brushing aside what upset you.",
    shared: {
      title: "What you shared",
      nowLabel: "Monday · About A.",
      now: "A. cancelled our Friday dinner that afternoon. I didn't hear from them over the weekend. Today, flowers arrived. I'm still upset.",
      earlierLabel: "From your earlier note · Friday",
      earlier: "After the cancellation, I told A. I needed the weekend to myself. We didn't agree when we'd talk again.",
    },
    picture: {
      title: "A fuller picture",
      advice: "The late cancellation still matters. You asked for the weekend to yourself, so they may have been giving you space. The flowers alone don't explain what happened.",
      sayLabel: "Something you could say",
      say: "Thank you for the flowers. I needed the weekend to myself, and I'm still disappointed about Friday. Can we talk tonight?",
    },
    later: {
      title: "A week later",
      updateLabel: "Your update · The following Monday",
      update: "We talked last Monday. A. apologised for cancelling late and suggested another dinner. We went on Saturday.",
      advice: "An apology and a kept plan are encouraging. It will take more time to see whether that follow-through continues.",
    },
  },
};
